export default "__VITE_ASSET__DBSPIuRq__"